import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Biathlon = () => {
  return (
    <SportsLayoutComp name={'Biathlon'}/>
  )
}

export default Biathlon